import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Button } from "../components/ui/button";
import { api } from "../lib/api";

export default function VoucherSuccess() {
  const [params] = useSearchParams();
  const [voucher, setVoucher] = useState(null);
  const [failed, setFailed] = useState(false);
  const vid = params.get("vid");
  const sessionId = params.get("session_id");

  useEffect(() => {
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.post(`/vouchers/${vid}/confirm`, { session_id: sessionId });
        setVoucher(data);
      } catch (e) {
        tries += 1;
        if (tries > 6) setFailed(true);
        else setTimeout(poll, 1500);
      }
    };
    if (vid && sessionId) poll();
    else setFailed(true);
  }, [vid, sessionId]);

  return (
    <div data-testid="voucher-success-page" className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-6">
      <div className="max-w-md w-full rounded-2xl border border-border/60 bg-card p-10 text-center">
        {!voucher && !failed && (
          <>
            <Loader2 className="w-10 h-10 text-primary mx-auto animate-spin" />
            <h1 className="font-display text-2xl mt-6">Confirming your payment...</h1>
          </>
        )}
        {voucher && (
          <>
            <CheckCircle2 className="w-12 h-12 text-primary mx-auto" />
            <h1 className="font-display text-3xl mt-6">Voucher ready!</h1>
            <p className="text-muted-foreground mt-3">
              £{Number(voucher.amount).toFixed(2)} for {voucher.recipient_name} at {voucher.restaurant_name}.
              We've emailed the details — keep this code safe:
            </p>
            <p data-testid="voucher-code" className="mt-6 font-mono text-2xl tracking-widest text-primary">{voucher.code}</p>
            <Link to="/restaurants">
              <Button data-testid="voucher-browse-btn" className="mt-8 rounded-full px-8">Discover more restaurants</Button>
            </Link>
          </>
        )}
        {failed && (
          <>
            <XCircle className="w-12 h-12 text-destructive mx-auto" />
            <h1 className="font-display text-2xl mt-6">We couldn't confirm your payment</h1>
            <p className="text-muted-foreground mt-3">If you were charged, contact the restaurant and they'll sort it out.</p>
          </>
        )}
      </div>
    </div>
  );
}
